import { render, staticRenderFns } from "./SelectUserGroupModal.vue?vue&type=template&id=3bef5132&scoped=true&"
import script from "./SelectUserGroupModal.vue?vue&type=script&lang=ts&"
export * from "./SelectUserGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef5132",
  null
  
)

export default component.exports